@if (enabled()) {
  @if (expanded()) {
    <div
      class="dev-context-banner-spacer"
      [style.height.px]="bannerHeight()"
      aria-hidden="true"
    ></div>
  }
  <section
    #bannerPanel
    id="dev-context-banner-panel"
    class="dev-context-banner"
    [class.dev-context-banner--collapsed]="!expanded()"
    [attr.hidden]="expanded() ? null : ''"
    aria-label="Development context"
  >
    <div class="dev-context-banner__details">
      @for (section of panelSections(); track section.trackId) {
        <div class="dev-context-banner__subsection">
          <h3
            class="dev-context-banner__subsection-title app-type-meta-strong app-tone-text-primary"
          >
            {{ section.title }}
          </h3>
          <dl class="dev-context-banner__grid">
            @for (row of section.rows; track row.label) {
              <div class="dev-context-banner__cell">
                <dt
                  class="dev-context-banner__label app-type-meta-strong app-tone-text-heading-quiet"
                >
                  {{ row.label }}
                </dt>
                <dd class="dev-context-banner__value app-type-small app-tone-text-default">
                  <span class="dev-context-banner__value-text">{{ row.value }}</span>
                  <button
                    type="button"
                    class="dev-context-banner__copy"
                    (click)="copyValueToClipboard(row.value)"
                    [attr.aria-label]="'Copy ' + row.label + ' to clipboard'"
                  >
                    <span class="pi pi-copy" aria-hidden="true"></span>
                  </button>
                </dd>
              </div>
            }
          </dl>
          @if (section.actions.length > 0) {
            <div class="dev-context-banner__actions">
              @for (action of section.actions; track action.label) {
                <div class="dev-context-banner__action">
                  @if (action.input; as inputConfig) {
                    <span
                      class="dev-context-banner__action-input-label app-type-meta-strong app-tone-text-heading-quiet"
                      [attr.id]="'dev-context-action-label-' + section.trackId + '-' + action.label"
                    >
                      {{ inputConfig.label }}
                    </span>
                    <div class="dev-context-banner__action-controls">
                      <input
                        type="text"
                        class="dev-context-banner__action-field app-type-small"
                        [value]="actionInputValue(section.trackId, action)"
                        [placeholder]="inputConfig.placeholder ?? ''"
                        [disabled]="runningActionKey() !== null"
                        [attr.aria-labelledby]="
                          'dev-context-action-label-' + section.trackId + '-' + action.label
                        "
                        (input)="
                          setActionInputValue(section.trackId, action, $any($event.target).value)
                        "
                      />
                      <button
                        type="button"
                        class="app-btn app-btn--outline app-btn--compact dev-context-banner__action-button"
                        [disabled]="runningActionKey() !== null"
                        [attr.aria-busy]="isActionRunning(section.trackId, action)"
                        (click)="runAction(section.trackId, action)"
                      >
                        {{ action.label }}
                      </button>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="app-btn app-btn--outline app-btn--compact"
                      [disabled]="runningActionKey() !== null"
                      [attr.aria-busy]="isActionRunning(section.trackId, action)"
                      (click)="runAction(section.trackId, action)"
                    >
                      {{ action.label }}
                    </button>
                  }
                  @if (actionMessage(section.trackId, action); as message) {
                    <span class="dev-context-banner__action-message app-type-small">
                      {{ message }}
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </section>
  <button
    type="button"
    class="dev-context-hud__fab"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="expanded() ? 'dev-context-banner-panel' : null"
    [attr.aria-label]="expanded() ? 'Hide development context' : 'Show development context'"
    [attr.title]="expanded() ? 'Hide development context' : 'Show development context'"
  >
    <span class="pi pi-code" aria-hidden="true"></span>
  </button>
}
